import React, { useCallback, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { pushAdoptsBuyerModal } from '../../../Modals/redux/actionCreators';
import { useRestrictToLoggedInAndVerified } from '../../../utils/hooks/useRestrictToLoggedInAndVerified';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { getHasBuyItNow, getPrice } from '../../../utils/adoptables';
import { ElementVisibilityContext } from '../../ElementVisibilityContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './AdoptableBuyer.scss';
export const AdoptableBuyer = ({ deviation, className })=>{
    const { elementGroups: { adoptableBuyer: adoptableBuyerElementVisibility } } = useContext(ElementVisibilityContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();
    const isMovedAdoptsInfo = useFlag('moved_exclusives_block');
    const isMobile = useContext(MobileContext);
    const openManageOfferModal = useCallback(()=>{
        dispatch(pushAdoptsBuyerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    const restrictedOpenManageOfferModal = restrictToLoggedInAndVerified(ReferralType.ACTION_BAR, undefined, openManageOfferModal);
    const openViewOffersModal = useCallback(()=>{
        dispatch(pushAdoptsBuyerModal(deviation, 'view-offers'));
    }, [
        deviation,
        dispatch
    ]);
    const gotoCheckout = useCallback(()=>{
        var _deviation_extended_adoptable_fixedPrice, _deviation_extended_adoptable, _deviation_extended;
        var _deviation_extended_adoptable_fixedPrice_subproductId;
        window.location.assign(Url.checkoutLink((_deviation_extended_adoptable_fixedPrice_subproductId = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : (_deviation_extended_adoptable_fixedPrice = _deviation_extended_adoptable.fixedPrice) === null || _deviation_extended_adoptable_fixedPrice === void 0 ? void 0 : _deviation_extended_adoptable_fixedPrice.subproductId) !== null && _deviation_extended_adoptable_fixedPrice_subproductId !== void 0 ? _deviation_extended_adoptable_fixedPrice_subproductId : 0));
    }, [
        deviation
    ]);
    const restrictedGoToCheckout = restrictToLoggedInAndVerified(ReferralType.ACTION_BAR, undefined, gotoCheckout);
    const hasBuyItNow = getHasBuyItNow(deviation);
    const price = getPrice(deviation);
    if (isMovedAdoptsInfo && isMobile) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, (adoptableBuyerElementVisibility === null || adoptableBuyerElementVisibility === void 0 ? void 0 : adoptableBuyerElementVisibility.buyItNow) && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        biData: BiData({
            evid: 750,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            purchase_price: parseFloat(price),
            sectionname: 'action_bar'
        }),
        onClick: restrictedGoToCheckout,
        className: s['button']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })), (adoptableBuyerElementVisibility === null || adoptableBuyerElementVisibility === void 0 ? void 0 : adoptableBuyerElementVisibility.makeOffer) && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: hasBuyItNow ? 'solid' : 'outline',
        size: 'medium',
        rounded: true,
        biData: BiData({
            evid: 751,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        }),
        onClick: restrictedOpenManageOfferModal,
        className: s['button']
    }, t('actionbar.adoptables.makeOffer')), (adoptableBuyerElementVisibility === null || adoptableBuyerElementVisibility === void 0 ? void 0 : adoptableBuyerElementVisibility.manageOffer) && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: hasBuyItNow ? 'solid' : 'outline',
        size: 'medium',
        rounded: true,
        biData: BiData({
            evid: 753,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        }),
        onClick: openManageOfferModal,
        className: s['button']
    }, t('actionbar.adoptables.manageOffer')), (adoptableBuyerElementVisibility === null || adoptableBuyerElementVisibility === void 0 ? void 0 : adoptableBuyerElementVisibility.viewOffers) && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: hasBuyItNow ? 'solid' : 'outline',
        size: 'medium',
        rounded: true,
        onClick: openViewOffersModal,
        className: s['button'],
        biData: BiData({
            evid: 746,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        })
    }, t('actionbar.adoptables.viewOffers'))));
};
AdoptableBuyer.displayName = 'AdoptableBuyer';
export default AdoptableBuyer;
